import { render, staticRenderFns } from "./o-qr-reader.vue?vue&type=template&id=4fcb1542&"
import script from "./o-qr-reader.vue?vue&type=script&lang=js&"
export * from "./o-qr-reader.vue?vue&type=script&lang=js&"
import style0 from "./o-qr-reader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports